import React, { useMemo, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../../../hooks/common";
import { fetchGetOrderTrack, fetchGetMessage } from "../../../../../../../api";
import Header from "../../../../../../components/header";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchUnifiedProcessing } from "../../../../utils";
import PackageTracing from "../fragments/package-tracking";
import Skeleton from '../../../../components/skeleton/index';


const FullPackageSub = props =>{
    const { packages } = props;
    const [currentIndex, setCurrentIndex] = useState(0);

    const currentPackage = useMemo(() =>{
        return packages?.[currentIndex];
    }, [packages, currentIndex]);

    return <div className={cls.FullPackageSub}>
        <div className={cls.PackageTabs}>
            {
                packages?.map((parcel, index)=>(
                    <span 
                        className={`${cls.TabItem} ${currentIndex===index?cls.Active:''}`} 
                        key={parcel?.trackingId+index} 
                        onClick={() =>setCurrentIndex(index)}
                    >
                        {parcel?.name}
                    </span>
                ))
            }
        </div>

        <div className={cls.PackageImages}>
            {
                currentPackage?.products?.map((product, index)=>(
                    <div className={cls.Image} key={index+currentPackage?.trackingId}>
                        <img src={product?.imageURL} alt="IMAGE" />
                    </div>
                ))
            }
        </div>
        
        {
            currentPackage?.trackingId && <PackageTracing parcelPackage={currentPackage} />
        }
    </div>
}

const OrderFullPackageTrack = props =>{
    useStyles(cls);
    const params = useParams();
    const query = useQuery();
    const Intl = useIntl();
    const [trackingData, setTrackingData] = useState(null);
    const [deliveryTip, setDeliveryTip] = useState(null);

    useEffect(async () =>{
        try {
            let response = await fetchGetOrderTrack(params?.orderId || query?.orderId);
            setTrackingData(fetchUnifiedProcessing(response));

            let response2 = await fetchGetMessage("M1645");
            setDeliveryTip(fetchUnifiedProcessing(response2));
        } catch (error) {
            console.log('error', error)
        }
    }, []);

    const disposeOrderId = useMemo(() =>{
        return params?.orderId || query?.orderId;
    }, []);

    return <div className={cls.OrderFullPackageTrack}>
        <Header 
            centerSlot={Intl.formatMessage({ id: "logisticsInfo", defaultMessage: "Logistics Information" })} 
            rightSlot={
                <Link to={`/user/faq/support-ticket?id=${disposeOrderId}`} className={cls.RightIcon}>
                    <Iconfont className={cls.Icon}>&#xe716;</Iconfont>
                </Link>
            }
        />
        
        {
            !!trackingData?.packages ? <React.Fragment>
                {
                    deliveryTip?.message && <div className={cls.DeliveryTip}>
                        {deliveryTip.message}
                    </div>
                }

                <FullPackageSub packages={trackingData.packages} />
            </React.Fragment> : <React.Fragment>
                <Skeleton />
            </React.Fragment>
        }

        

        
    </div>
}

export default OrderFullPackageTrack;